export default __webpack_public_path__ + "static/media/cashCardPlusPayToRestaurant.fc8b686d.svg";